// Emergent OAuth helper
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const EMERGENT_AUTH = "https://auth.emergentagent.com/";

export function startEmergentGoogleAuth() {
    // Use the browser's dynamic top-level origin so cookies (incl. Google session) are preserved.
    // We navigate the TOP window when this app is embedded in an iframe (e.g. Emergent app-builder
    // preview), otherwise the OAuth flow starts in a fresh iframe context that doesn't share the
    // user's existing Google sign-ins, forcing a full email/password prompt every time.
    const topWin = (() => {
        try {
            // Accessing window.top.location.href throws cross-origin on some hosts; that's fine —
            // we only need to *set* it, which is allowed cross-origin.
            return window.top || window;
        } catch (_) {
            return window;
        }
    })();

    // Redirect back to the same origin the user is currently viewing.
    const origin =
        (() => {
            try {
                return topWin.location.origin || window.location.origin;
            } catch (_) {
                return window.location.origin;
            }
        })();
    const redirectUrl = origin + "/app/match";

    const url = `${EMERGENT_AUTH}?redirect=${encodeURIComponent(redirectUrl)}`;

    try {
        topWin.location.href = url;
    } catch (_) {
        window.location.href = url;
    }
}
